// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-row {
  display: flex;
  gap: 20px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content {
  width: 612px;
  flex-shrink: 0;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .Polaris-Card {
  height: 100%;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .Polaris-Card .card-inner {
  padding: 16px;
  height: 100%;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .Polaris-Card .card-inner.card-inner--column {
  display: flex;
  flex-direction: column;
  gap: 12px;
}


.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .Polaris-Card .card-inner .BC-Switch-Status {
  height: 16px;
  width: 34px;
  margin-right: 8px;
  display: inline-flex;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .Polaris-Card .card-inner .BC-Switch-Status__Bar {
  width: 34px;
  height: 16px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .Polaris-Card .card-inner .BC-Switch-Status__Dot {
  width: 16px;
  height: 16px;
  transform: translateX(0);
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .Polaris-DataTable__Table {
  border: 1px solid #E1E3E5;
  border-radius: 8px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .Polaris-DataTable__Cell:first-child {
  width: 45%;
  white-space: wrap;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .Polaris-DataTable__Cell:last-child {
  width: 55%;
  white-space: wrap;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .Polaris-DataTable__TableRow:nth-child(odd) {
  background-color: #FAFBFB;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .guide {
  margin-bottom: 8px;
  margin-top: 16px;
  text-align: left;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .guide .Polaris-Link {
  display: inline-flex;
  align-items: center;
  text-decoration: underline;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .guide .Polaris-Link .Polaris-Icon {
  margin: 0;
  width: 16px;
  height: 16px;
  margin-left: 2px;
}


.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .Polaris-DataTable__Navigation {
  display: none;
}

.BC-Page.BC-Page__KlaviyoIntegration .BC-Switch-Status input:checked+.BC-Switch-Status__Bar .BC-Switch-Status__Dot {
  -webkit-transform: translateX(16px);
  -ms-transform: translateX(16px);
  transform: translateX(16px);
}

.BC-Page.BC-Page__KlaviyoIntegration .BC-Page__Title--Help {
  padding-left: 53px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .divider {
  border: 1px solid #E1E3E5;
  margin-bottom: 24px;
}

.BC-Klaviyo-Recommendation__ListToolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.BC-Klaviyo-Recommendation__ListTitleGroup {
  display: flex;
  align-items: center;
  gap: 8px;
}

.BC-Klaviyo-Recommendation__CountBadge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 2px 8px;
  border-radius: 8px;
  background: #E8E8E8;
  font-size: 12px;
}

.BC-Klaviyo-Recommendation__MoreActionsMenu {
  min-width: 130px;
  text-align: left;
}

.BC-Klaviyo-Recommendation__ListLoading {
  display: flex;
  justify-content: center;
  padding: 24px 0;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item {
  display: grid;
  grid-template-columns: 1fr 220px;
  align-items: center;
  gap: 32px;
  padding: 12px 16px;
  border: 1px solid transparent;
  border-radius: 4px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item.recommendation-item--odd {
  background: #FFFFFF;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item.recommendation-item--even {
  background: #FAFBFB;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item:hover {
  border: 1px solid #1F5199;
  background: #EDF4FE;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item__title {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .recommendation-item__title .text-ai {
  background: linear-gradient(135.64deg, #C830E1 16.99%, #FE4A25 84.55%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 600;
  font-size: 10px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .recommendation-item__title .star {
  width: 12px;
  height: 12px;
  min-width: 12px;
  min-height: 12px;
  flex-shrink: 0;
}


.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .recommendation-item__title .Polaris-Badge {
  background: #FF30001A;
  padding: 2px 6px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .recommendation-item__title .Polaris-Badge>span {
  display: flex;
  align-items: center;
  gap: 2px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item__header {
  display: grid;
  grid-template-columns: 1fr 220px;
  align-items: center;
  padding: 12px 16px;
  margin-bottom: 8px;
  background: #FAFBFB;
  border: 1px solid #E1E3E5;
  border-radius: 8px;
  font-weight: 600;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item__header > :last-child {
  text-align: center;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .recommendation-item__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

/* 8px flex gap between action buttons, +4px on the more-actions trigger = 12px before it */
.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .recommendation-item__actions .recommendation-item__more-actions {
  margin-left: 4px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .recommendation-item__actions .recommendation-item__action-button .Polaris-Button {
  padding: 5px 12px !important;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .recommendation-item__actions .recommendation-item__more-actions .Polaris-Button {
  background: none;
  color: #202223;
  border: none;
  box-shadow: none;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .recommendation-item__actions .recommendation-item__more-actions .Polaris-Button:disabled,
.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .recommendation-item__actions .recommendation-item__more-actions .Polaris-Button[disabled] {
  background: none;
  color: #8C9196;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .text-coming-soon {
  font-weight: 600;
  font-size: 16px;
  margin: 2px 0;
  line-height: 24px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .card-inner--center {
  text-align: center;
  padding-bottom: 20px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .klaviyo-event {
  border: 1px solid #E1E3E5;
  border-radius: 8px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .klaviyo-event .klaviyo-event-collapse__toggle {
  background-color: #FAFBFB;
  padding: 12px 16px;
  display: flex;
  gap: 4px;
  font-weight: 600;
  cursor: pointer;
  border-bottom: 1px solid #E1E3E5;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .klaviyo-event .klaviyo-event-wrapper:first-child .klaviyo-event-collapse__toggle {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .klaviyo-event .klaviyo-event-wrapper:last-child .klaviyo-event-collapse__toggle {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border-bottom: 0;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .klaviyo-event .klaviyo-event-collapse__content {
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #E1E3E5;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .klaviyo-event .klaviyo-event-collapse__content .klaviyo-event-collapse__content__title {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-basis: 50%;
  padding-left: 24px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .klaviyo-event .klaviyo-event-collapse__content p {
  flex-basis: 50%;
  text-align: left;
}

/* Figma node 23395:77999 (Get code modal) — 980px total (600 info + 380 preview). */
.BC-Page.BC-Page__KlaviyoIntegration~#PolarisPortalsContainer .Polaris-Modal-Dialog--sizeLarge {
  max-width: 980px;
}

.BC-Page.BC-Page__KlaviyoIntegration .card-inner__flex {
  display: flex;
  align-items: center;
  gap: 8px;
}

.BC-Page.BC-Page__KlaviyoIntegration .card-inner__flex .BC-Checkbox-Status {
  margin-right: 0;
}

.BC-Page.BC-Page__KlaviyoIntegration .card-inner__instruction {
  padding-left: 42px;
  margin-top: 4px;
  color: rgb(109, 113, 117);
  display: flex;
}

.BC-Page.BC-Page__KlaviyoIntegration .card-inner__instruction .Polaris-Link {
  display: inline-flex;
  margin-left: 4px;
  text-decoration: underline;
}

.BC-Page.BC-Page__KlaviyoIntegration .card-inner__instruction .Polaris-Icon {
  margin: 0;
  width: 18px;
  height: 18px;
  margin-left: 2px;
}

.BC-Page.BC-Page__KlaviyoIntegration .card-inner__instruction .Polaris-Icon .Polaris-Icon__Svg {
  fill: rgb(44, 110, 203);
}

.klaviyo-preview-modal {
  display: flex;
}

.klaviyo-preview-modal .klaviyo-preview-modal__guideline {
  width: 600px;
  padding: 16px;
  border-right: 1px solid #E1E3E5;
}

.klaviyo-preview-modal .klaviyo-preview-modal__guideline .title-section {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 8px;
}

.klaviyo-preview-modal .klaviyo-preview-modal__guideline .Polaris-Link {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
}

.klaviyo-preview-modal .klaviyo-preview-modal__guideline .feed-name {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  gap: 4px;
}

/* Figma node 23395:78022 — gray pill (not Polaris' Badge component), copy icon embedded inside
   it rather than a separate button next to it. */
.BC-Klaviyo-FeedBadge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  background: #E8E8E8;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-family: inherit;
}

.BC-Klaviyo-FeedBadge__Text {
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  color: #616161;
}

.BC-Klaviyo-FeedBadge .Polaris-Icon {
  width: 14px;
  height: 14px;
  margin: 0;
}

.klaviyo-preview-modal .klaviyo-preview-modal__guideline .Polaris-Icon {
  margin: 0;
}

.klaviyo-preview-modal .klaviyo-preview-modal__guideline .guide-content .Polaris-Icon .Polaris-Icon__Svg {
  fill: #2C6FCD;
}

.klaviyo-preview-modal .klaviyo-preview-modal__guideline .code .Polaris-Icon .Polaris-Icon__Svg {
  fill: #8C9196;
}

.klaviyo-preview-modal .klaviyo-preview-modal__guideline .code .Polaris-Icon:hover .Polaris-Icon__Svg {
  fill: rgb(26, 28, 29);
}

.klaviyo-preview-modal .klaviyo-preview-modal__guideline .klaviyo-preview-modal__actions .Polaris-ButtonGroup {
  gap: 20px;
}

.klaviyo-preview-modal .klaviyo-preview-modal__guideline .klaviyo-preview-modal__actions .Polaris-ButtonGroup__Item {
  margin: 0;
}

/* Figma node 23395:78025 / 23395:78040 — bordered gray box, not just a scroll container. */
.klaviyo-preview-modal .klaviyo-preview-modal__guideline .code {
  position: relative;
  padding: 12px 16px;
  background: #F5F5F5;
  border: 1px solid #D0D0D0;
  border-radius: 8px;
  max-height: 414px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-gutter: stable;
}

.klaviyo-preview-modal .klaviyo-preview-modal__guideline .code p {
  white-space: pre-wrap;
  overflow-wrap: break-word;
  word-break: break-word;
  margin: 0;
  font-family: Monaco, monospace;
  font-size: 12px;
  color: #202223;
}

/* Figma node 23395:78019/78040: copy icon in the box's top-right corner, set in by the box's own
   padding. Sticky, not absolute — the box scrolls (max-height above), and an absolute child would
   scroll away with long source code; sticky keeps it in view, like master's copy button did.
   top matches the box's top padding so the icon doesn't jump when scrolling starts. */
.klaviyo-preview-modal .klaviyo-preview-modal__guideline .code .Polaris-Button {
  position: sticky;
  top: 0;
  right: 0.25rem;
  float: right;
  margin-left: 8px;
  padding: 0;
  width: 16px;
  height: 16px;
  min-width: unset;
  min-height: unset;
}

.klaviyo-preview-modal .loading-sync {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 20px 0;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content {
  flex: 1;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .title-preview {
  padding: 12px;
  width: 100%;
  border-bottom: 1px solid #E1E3E5;
  text-align: center;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .preview-content {
  padding: 16px 20px;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .preview-content--AI {
  overflow: hidden;
}

/* Get code for a merchant-created recommendation shows up to 9 products (3x3 / 6 per row). The
   Preview column matches the height of its sibling, the guideline column (the row stretches both),
   and the products scroll inside it instead of stretching the modal. \`height: 0\` + \`flex-grow\`
   keeps the products out of the column's own height, so only the guideline column sizes the row;
   the scroll area then fills whatever the "Preview" title leaves. Declared after --AI so its
   overflow-y wins for AI types too. */
.klaviyo-preview-modal .klaviyo-preview-modal__preview-content--fit {
  display: flex;
  flex-direction: column;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content--fit .preview-content.preview-content--scroll .title-type {
  /* BRD UC 3.2: a merchant-created recommendation's title renders exactly as entered — master's
     uppercase on .title-type (declared below, 4 classes) stays for the 6 default recommendations'
     legacy modal. The extra .preview-content class here (5 classes) is what lets this win. */
  text-transform: none;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content--fit .preview-content--scroll {
  flex: 1 1 0;
  height: 0;
  min-height: 0;
  overflow-y: auto;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .preview-content .title-type {
  font-weight: 600;
  font-size: 20px;
  text-transform: uppercase;
  line-height: 32px;
  text-align: center;
  margin-bottom: 16px;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container {
  display: flex;
  flex-wrap: wrap;
  column-gap: 20px;
  row-gap: 16px;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item {
  width: calc(50% - 10px);
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__thumbnail {
  margin-bottom: 10px;
  text-align: center;
  aspect-ratio: 1;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__thumbnail img {
  max-width: 100%;
  height: 100%;
  width: 100%;
  object-fit: contain;
  object-position: center;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__info__title {
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: rgb(32, 34, 35);
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__info__price-wrapper {
  text-align: center;
  margin-top: 6px;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__info__price {
  font-weight: 500;
  color: #6D7175;
  text-align: center;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__info__compare-price {
  color: #9B9B9B;
  text-decoration: line-through;
  margin-left: 6px
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__thumbnail .Polaris-SkeletonThumbnail {
  max-width: 100%;
  height: 100%;
  width: 100%;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__info .Polaris-SkeletonDisplayText__DisplayText {
  width: 100%;
  margin: auto;
  height: 20px;
  max-width: 6.5rem;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__info>.Polaris-SkeletonDisplayText__DisplayText {
  max-width: 8rem;
  height: 24px;
}

.callback-klaviyo {
  box-shadow: 0px 2px 10px 0px #0000001A, 0px 0px 2px 0px #00000033;
  background-color: #fff;
  border-radius: 8px;
  padding: 40px 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.callback-klaviyo .callback-klaviyo__title {
  font-weight: 600;
  font-size: 28px;
  line-height: 32px;
  text-align: center;
  margin-top: 12px;
  margin-bottom: 24px;
}

/* Klaviyo recommendation rule builder (create/edit Tab 1). Polaris' Stack spacing tokens don't
   include a 16px step (loose=20px, baseTight=12px) — override the token directly rather than
   reaching for inline style. */
.BC-Page.BC-Page__KlaviyoRecommendationBuilder .Polaris-Stack--spacingLoose {
  --pc-stack-spacing: 16px;
}

/* Two-tone card per Figma node 23395:78506 (Group Condition): a white header band for the
   badge/label/delete, a light gray (#F6F6F7) body for the fields. */
.BC-Klaviyo-Recommendation__RuleRow {
  border: 1px solid #E1E3E5;
  border-radius: 8px;
  overflow: hidden;
}

.BC-Klaviyo-Recommendation__RuleRow-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
}

.BC-Klaviyo-Recommendation__RuleRow-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 1px solid #C9CCCF;
  font-size: 12px;
  color: #6D7175;
  flex-shrink: 0;
  background: #FFFFFF;
}

.BC-Klaviyo-Recommendation__RuleRow-label {
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.BC-Klaviyo-Recommendation__RuleRow-delete {
  margin-left: auto;
}

.BC-Klaviyo-Recommendation__RuleRow-body {
  padding: 16px 6px 16px 12px;
  background: #F6F6F7;
  display: flex;
  flex-direction: column;
}

.BC-Klaviyo-Recommendation__RuleRow-rangeError {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  margin-top: 4px;
  color: #D72C0D;
  margin-left: 1rem;
}

.BC-Klaviyo-Recommendation__RuleRow-rangeError .Polaris-Icon {
  margin: unset;
}

/* Line 1: attribute select + the conductor/value group side by side.
   Every control shares one height via flex stretch, cascaded down through each wrapper with
   height: 100% + box-sizing: border-box (so a wrapper's own border never adds on top of the
   stretched size) instead of the same pixel value hardcoded at every nesting level. */
.BC-Klaviyo-Recommendation__RuleRow-line1 {
  display: flex;
  gap: 8px;
  align-items: stretch;
}

.BC-Klaviyo-Recommendation__RuleRow-attribute {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
}

/* The direct child here is RenderSelect's own unstyled wrapper div (label/tooltip — empty when,
   as here, no label prop is passed — then the Polaris <Select>). Giving it height: 100% lets the
   stretched height from -line1 keep propagating down to the actual Polaris control below.
   flex: 1 1 auto is needed too — making -attribute/-conductor \`display: flex\` (above) turned
   this div into a flex item, which shrinks to its content's width by default instead of filling
   the row like a plain block-level child would. */
.BC-Klaviyo-Recommendation__RuleRow-attribute > div {
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  box-sizing: border-box;
}

/* -attribute now renders via react-select (RenderSelect3V2, classNamePrefix="BC-Select") so it
   can show a per-option hint + icon — Polaris' native <Select> can't render anything but plain
   text inside an <option>. react-select's own root container (SelectContainer) renders with NO
   class at all in its default state (\`.BC-Select\`/\`.BC-Select-container\` never match anything
   real — its cx() state keys are all false), which is the one link a height:100% chain can't
   pass through by class. RenderLabelTooltip renders nothing when no label is passed, so
   SelectContainer is the only real DOM child here — reachable structurally instead: made
   display:flex so its own child (.control) stretches to fill it the same native way -line1
   stretches -attribute/-conductor, no fixed px value needed anywhere in the chain. */
.BC-Klaviyo-Recommendation__RuleRow-attribute > div > div {
  display: flex;
  height: 100%;
  box-sizing: border-box;
}

/* Belt-and-suspenders: force border-box on every react-select sub-part here (value-container,
   indicators, etc.), not just .control — a single content-box element anywhere in this subtree
   would silently add its own border/padding on top of the stretched height, growing .control
   past the conductor's height despite the height:100% above. */
.BC-Klaviyo-Recommendation__RuleRow-attribute [class*='BC-Select'] {
  box-sizing: border-box !important;
}

.BC-Klaviyo-Recommendation__RuleRow-attribute .BC-Select__control {
  height: 100%;
  border: 1px solid #BABFC3 !important;
  border-radius: 4px !important;
  box-shadow: none !important;
  width: 100%;
}

/* REVIEWS.io attribute options' hint icon — sized to match the 14px hint text next to it
   instead of Polaris' default 20px Icon size (Icon.css sets a fixed 1.25rem box the inner svg
   fills at 100%, so both need overriding together). */
.BC-Klaviyo-Recommendation__AttributeHintIcon {
  display: inline-flex;
  margin-left: 4px;
  vertical-align: text-bottom;
}

.BC-Klaviyo-Recommendation__AttributeHintIcon .Polaris-Icon {
  width: 14px;
  height: 14px;
}

/* Conductor + value group (Figma 23736:81860 "<= | 90 \$", 23736:82019 "is not | select"): the
   conductor select merged with its value field into one bordered control. */
.BC-Klaviyo-Recommendation__RuleRow-valueGroup {
  /* Figma 23736:81860/82019 split: ~41% attribute, ~55% conductor + value. */
  flex: 1.35 1 0;
  min-width: 0;
  display: flex;
}

/* A LIST rule's picked values, in their own full-width row under -line1 (right-aligned, so they
   line up under the value control) — however many lines they wrap to, -line1's controls keep
   their single-line height. Deliberately no width-relative offset/flex split here: the rules
   list (a Polaris Stack, a column flexbox) measures each rule's natural height in a pass where
   such widths resolve narrower, so the tags wrapped there and left ~one tag-line of empty space
   under the card. */
.BC-Klaviyo-Recommendation__RuleRow-tagsRow {
  display: block;
}

/* Margin lives here, not on -tagsRow: RenderSelectedTags renders nothing when no value is picked,
   so an empty rule adds no extra space. Plain flex \`gap\` instead of a Polaris Stack: Stack spaces
   its items through margins driven by the inherited --pc-stack-spacing variable, which this
   builder overrides for its own Stacks (see .Polaris-Stack--spacingLoose above). */
.BC-Klaviyo-Recommendation__RuleRow-tags {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 4px;
  margin-top: 8px;
}
.BC-Klaviyo-Recommendation__RuleRow-compound {
  display: flex;
  flex: 1 1 0;
  min-width: 0;
  min-height: 36px;
  border: 1px solid #C9CCCF;
  border-radius: 4px;
  overflow: hidden;
}

/* Conductor segment: Surface/Depressed (#EDEEEF) background, no border of its own — the
   -compound wrapper draws the one outer border, this only the divider. Same "merge two
   controls" technique as merchandising-v2's .wrap-attribute-field. */
.BC-Klaviyo-Recommendation__RuleRow-compound-conductor {
  /* Fits the widest operator ("is not") + chevron; anything wider squeezed the value field's
     "select" placeholder in the 350px settings panel. */
  flex: 0 0 76px;
  border-right: 1px solid #C9CCCF;
}

.BC-Klaviyo-Recommendation__RuleRow-compound-conductor > div,
.BC-Klaviyo-Recommendation__RuleRow-compound-conductor .Polaris-Select,
.BC-Klaviyo-Recommendation__RuleRow-compound-conductor .Polaris-Select__Content {
  height: 100%;
  box-sizing: border-box;
}

.BC-Klaviyo-Recommendation__RuleRow-compound-conductor .Polaris-Select__Backdrop {
  border: none !important;
  box-shadow: none !important;
  border-radius: 0;
  background-color: #EDEEEF;
}

.BC-Klaviyo-Recommendation__RuleRow-compound-conductor .Polaris-Select__Input:focus ~ .Polaris-Select__Backdrop::after {
  box-shadow: none;
  outline: none;
}

.BC-Klaviyo-Recommendation__RuleRow-compound-field {
  flex: 1 1 0;
  min-width: 0;
}

/* Pin the field's own box to a constant height so hovering/focusing between inputs can't grow
   or shrink it — Polaris toggles focus/hover via classes on these elements, not just
   box-shadow/border, so height has to be pinned directly rather than relying on the state being
   visually invisible. */
.BC-Klaviyo-Recommendation__RuleRow-compound-field .Polaris-TextField,
.BC-Klaviyo-Recommendation__RuleRow-compound-field .Polaris-TextField__Input,
.BC-Klaviyo-Recommendation__RuleRow-compound-field .Polaris-Select,
.BC-Klaviyo-Recommendation__RuleRow-compound-field .Polaris-Select__Input {
  height: 36px !important;
  box-sizing: border-box !important;
}

.BC-Klaviyo-Recommendation__RuleRow-compound-field .Polaris-TextField__Backdrop,
.BC-Klaviyo-Recommendation__RuleRow-compound-field .Polaris-TextField__Backdrop:hover,
.BC-Klaviyo-Recommendation__RuleRow-compound-field .Polaris-TextField__Backdrop::after,
.BC-Klaviyo-Recommendation__RuleRow-compound-field .Polaris-Select__Backdrop,
.BC-Klaviyo-Recommendation__RuleRow-compound-field .Polaris-Select__Backdrop:hover,
.BC-Klaviyo-Recommendation__RuleRow-compound-field .Polaris-Select__Backdrop::after,
.BC-Klaviyo-RecommendationBuilder__Settings .Polaris-TextField__Input ~ .Polaris-TextField__Backdrop::after {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  border-radius: 0;
}

.BC-Klaviyo-Recommendation__RuleRow-compound-field input:hover,
.BC-Klaviyo-Recommendation__RuleRow-compound-field input:focus {
  outline: none !important;
  box-shadow: none !important;
}

.BC-Klaviyo-Recommendation__RuleRow-compound-field .BC-Select__control {
  border: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  /* react-select's control is flex-wrap: wrap — in the narrow settings panel the multi-select's
     dropdown arrow wrapped onto a second line, growing the whole rule (and only LIST rules) to
     ~70px. Keep it one line; the value container shrinks/clips instead. */
  flex-wrap: nowrap;
}

.BC-Klaviyo-Recommendation__RuleRow-compound-field .BC-Select__dropdown-indicator {
  padding: 8px 4px;
}

.BC-Klaviyo-Recommendation__RuleRow-compound-field .Polaris-TextField__Spinner {
}

/* .BC-Klaviyo-Recommendation__RuleRow-compound-field .Polaris-TextField__SpinnerIcon {
  width: 20px;
  height: 20px;
} */

.BC-Klaviyo-Recommendation__RuleRow-compound-field .Polaris-TextField__Segment {
  width: 20px;
  height: 14px;
  min-width: 20px;
  min-height: 14px;
  max-width: 20px;
  max-height: 14px;
  flex-shrink: 0;
}

/* "Filter criteria for recommended products" section header + Refresh button above the rule list. */
.BC-Klaviyo-Recommendation__FilterCriteriaHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

/* Rules count badge (e.g. "4/4 rules") shown once the limit is reached. */
.BC-Klaviyo-Recommendation__RulesLimitBadge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 8px;
  background: #FEDAD9;
  color: #8E1F0B;
  font-size: 12px;
}

/* Klaviyo recommendation builder — fullscreen chrome + left settings/right preview split,
   mirroring merchandising-v2/rule's .merchandising-rule-body/-settings/-preview structure
   (see merchandising.css) rather than a Polaris Page/Layout. */
.BC-Page.BC-Page__KlaviyoRecommendationBuilder .Polaris-FullscreenBar {
  position: fixed;
  width: 100%;
  top: 0;
}

/* Row 2 of the App Bridge drawer: exit + title hard-left, device toggle centred, actions hard-right. */
.BC-Page.BC-Page__KlaviyoRecommendationBuilder .BC-FullscreenBar .Polaris-FullscreenBar__BackAction {
  /* Design shows the exit icon only; the label stays in the DOM for screen readers. Polaris sizes
     Icon in rem, so zeroing the font hides the text without shrinking the icon. */
  font-size: 0;
  border-right: 1px solid #E1E3E5;
}

.BC-Page.BC-Page__KlaviyoRecommendationBuilder
  .BC-FullscreenBar
  .Polaris-FullscreenBar__BackAction
  .Polaris-Icon {
  margin-right: 0;
}

/* Equal-flex outer zones put the middle zone on the true centre of the bar, whatever the title
   length or action width — no negative-margin tuning like merchandising.css/theme-settings.css. */
.BC-Page.BC-Page__KlaviyoRecommendationBuilder .BC-FullscreenBar .BC-FullscreenBar-Content_Title,
.BC-Page.BC-Page__KlaviyoRecommendationBuilder
  .BC-FullscreenBar
  .Polaris-FullscreenBar__BackAction
  + .BC-FullscreenBar-Content
  .BC-FullscreenBar-Content_Title {
  margin: 0;
  flex: 1 1 0;
  min-width: 0;
  justify-content: flex-start;
}

.BC-Page.BC-Page__KlaviyoRecommendationBuilder
  .BC-FullscreenBar
  .BC-FullscreenBar-Content_Title
  > span {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.BC-Page.BC-Page__KlaviyoRecommendationBuilder .BC-FullscreenBar .BC-FullscreenBar-Content_Middle {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
}

.BC-Page.BC-Page__KlaviyoRecommendationBuilder .BC-FullscreenBar .BC-FullscreenBar-Content_Actions {
  flex: 1 1 0;
  display: flex;
  justify-content: flex-end;
}

.BC-Klaviyo-RecommendationBuilder__Body {
  display: flex;
  justify-content: space-between;
  margin-top: 3.5rem;
  padding: 0;
  gap: 20px;
}

.BC-Klaviyo-RecommendationBuilder__Loading {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 3.5rem;
  padding: 80px 0;
}

.BC-Klaviyo-RecommendationBuilder__Settings {
  width: 30%;
  min-height: 980px;
  background: #FFFFFF;
  border: 1px solid #E1E3E5;
}

/* Figma's Left sidebar (23395:78497) has no side padding around its Tabs — they sit flush
   against the pane's edges. Polaris' Tabs__Wrapper adds its own side padding by default. */
.BC-Page.BC-Page__KlaviyoRecommendationBuilder .Polaris-Tabs__Wrapper {
  padding: 0;
}

.BC-Klaviyo-RecommendationBuilder__Preview {
  width: 70%;
  display: flex;
  justify-content: center;
  padding-top: 20px;
  background: #F1F2F3;
}

.BC-Klaviyo-RecommendationBuilder__Content {
  margin-top: 16px;
  padding: 16px 20px 16px 16px;
}

.BC-Klaviyo-RecommendationBuilder__Content .Polaris-Card {
  border: none;
  box-shadow: none;
}

.BC-Klaviyo-RecommendationBuilder__Banner {
  margin-bottom: 16px;
}

.BC-Klaviyo-RecommendationBuilder__PreviewCount {
  margin-bottom: 8px;
}

.BC-Klaviyo-RecommendationBuilder__PreviewList {
  margin: 0;
  padding-left: 20px;
}

.BC-Klaviyo-RecommendationBuilder__PreviewLoading {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}

/* Klaviyo recommendation widget preview (Tabs 1-2 right column + Tab 3) */
.BC-Klaviyo-RecommendationPreview__Frame {
  margin: 0 auto;
}

.BC-Klaviyo-RecommendationPreview__Frame--desktop {
  width: 80%;
  height: 100%;
  overflow-y: auto;
}

.BC-Klaviyo-RecommendationPreview__Frame--mobile {
  max-width: 320px;
}

.BC-Klaviyo-RecommendationPreview__Inner {
  background: #FFFFFF;
  border-radius: 12px;
  padding: 48px 20px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Static — the "Product title"/"Product price"/"Button" config sections style each product
   item in the grid below (BRD Screen 3 #3-#5), not this heading; the heading itself has no
   font/size/color config in the BRD (Screen 3 #1 is just a checkbox + free text). No
   text-transform: BRD UC 3.2 renders the title case-sensitively, exactly as entered. */
.BC-Klaviyo-RecommendationPreview__Heading {
  text-align: center;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: #202223;
}

.BC-Klaviyo-RecommendationPreview__Row {
  display: flex;
  justify-content: center;
  gap: 40px;
}

.BC-Klaviyo-RecommendationPreview__Product {
  text-align: center;
  width: 160px;
}

/* Figma 23301:80994 (left) / 23301:80992 (right) — image and info side by side instead of
   stacked; JS decides image/info order for left vs right, this just lays them out in a row. */
.BC-Klaviyo-RecommendationPreview__Product--vertical {
  display: flex;
  align-items: center;
  gap: 20px;
  width: auto;
}

.BC-Klaviyo-RecommendationPreview__ProductInfo {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 180px;
  text-align: center;
}

/* .ProductImage's own margin-bottom is for the stacked horizontal card — spacing between image
   and info here is the flex row's own \`gap\` instead, so the image should sit flush/centered. */
.BC-Klaviyo-RecommendationPreview__Product--vertical .BC-Klaviyo-RecommendationPreview__ProductImage {
  margin: 0;
  flex-shrink: 0;
}

.BC-Klaviyo-RecommendationPreview__ProductImage {
  width: 160px;
  height: 160px;
  margin: 0 auto 10px;
  text-align: center;
  aspect-ratio: 1;
}

.BC-Klaviyo-RecommendationPreview__ProductImage img {
  max-width: 100%;
  height: 100%;
  width: 100%;
  object-fit: contain;
  object-position: center;
}

/* Mobile always renders one product per row (see widget-preview.jsx), so horizontal cards keep
   their desktop 160px size. Vertical cards follow Figma 23395:78177: full-width row, 123x150
   image, info fills the rest — left-aligned for "left vertically", right-aligned for "right
   vertically" (desktop keeps it centered), with a content-width button. */
.BC-Klaviyo-RecommendationPreview__Frame--mobile .BC-Klaviyo-RecommendationPreview__Product--vertical {
  width: 100%;
  gap: 16px;
}

.BC-Klaviyo-RecommendationPreview__Frame--mobile .BC-Klaviyo-RecommendationPreview__Product--vertical .BC-Klaviyo-RecommendationPreview__ProductImage {
  width: 123px;
  height: 150px;
  aspect-ratio: auto;
}

.BC-Klaviyo-RecommendationPreview__Frame--mobile .BC-Klaviyo-RecommendationPreview__ProductInfo {
  flex: 1;
  min-width: 0;
  width: auto;
  align-items: flex-start;
  text-align: left;
}

.BC-Klaviyo-RecommendationPreview__Frame--mobile .BC-Klaviyo-RecommendationPreview__Product--right .BC-Klaviyo-RecommendationPreview__ProductInfo {
  align-items: flex-end;
  text-align: right;
}

.BC-Klaviyo-RecommendationPreview__Frame--mobile .BC-Klaviyo-RecommendationPreview__Product--vertical .BC-Klaviyo-RecommendationPreview__ButtonWrap {
  margin-top: 12px;
}

.BC-Klaviyo-RecommendationPreview__Frame--mobile .BC-Klaviyo-RecommendationPreview__Product--vertical .BC-Klaviyo-RecommendationPreview__Button {
  width: auto;
  padding: 6px 16px;
}

/* Always 2 lines tall (longer titles clipped) so price and button line up across a row — the same
   box the email source code uses; email clients can't bottom-align with flex. */
.BC-Klaviyo-RecommendationPreview__ProductTitle {
  height: calc(var(--preview-line-height, 20px) * 2);
  overflow: hidden;
  line-height: var(--preview-line-height, 20px);
  margin-bottom: 6px;
  font-family: var(--preview-font);
  font-size: var(--preview-size);
  color: var(--preview-color);
}

.BC-Klaviyo-RecommendationPreview__Price {
  font-family: var(--preview-font);
  font-size: var(--preview-size);
}

.BC-Klaviyo-RecommendationPreview__SalePrice {
  color: var(--preview-color);
}

.BC-Klaviyo-RecommendationPreview__ComparePrice {
  text-decoration: line-through;
  color: var(--preview-color);
}

.BC-Klaviyo-RecommendationPreview__Rating {
  margin-top: 8px;
}

.BC-Klaviyo-RecommendationPreview__Stars {
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 1px;
}

.BC-Klaviyo-RecommendationPreview__Star--filled {
  color: #F0A93B;
}

.BC-Klaviyo-RecommendationPreview__Star--empty {
  color: #DDE2E7;
}

.BC-Klaviyo-RecommendationPreview__ReviewCount {
  margin-top: 4px;
  font-size: 12px;
  color: #9B9B9B;
}

.BC-Klaviyo-RecommendationPreview__ButtonWrap {
  margin-top: 8px;
}

.BC-Klaviyo-RecommendationPreview__Button {
  display: inline-block;
  box-sizing: border-box;
  width: 100%;
  padding: 8px 16px;
  border-radius: 100px;
  font-family: var(--preview-font);
  font-size: var(--preview-size);
  color: var(--preview-color);
  background: var(--preview-bg);
  text-align: center;
}

.BC-Klaviyo-RecommendationPreview__Empty {
  text-align: center;
  color: #6D7175;
}

.BC-Klaviyo-RecommendationPreview__DemoNote {
  margin: 0;
  text-align: center;
}

.BC-Klaviyo-RecommendationPreview__Loading {
  display: flex;
  justify-content: center;
  padding: 80px 0;
}

/* Widget UI tab (Customize widget UI, Figma node 23395:79477) — each section is a numbered
   "Group Condition" box, same visual pattern as the rule builder's RuleRow (bordered header +
   gray body), not a plain Polaris Card. */
.BC-Klaviyo-WidgetUiTab__Section {
  border: 1px solid #E1E3E5;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 16px;
}

.BC-Klaviyo-WidgetUiTab__Heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
}

.BC-Klaviyo-WidgetUiTab__HeadingLeft {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Figma 23525:79672 — "Guideline: How to integrate with REVIEWS.io" link, indented to align
   under the checkbox's own label text (20px checkbox + 8px gap), shown only while disconnected. */
.BC-Klaviyo-WidgetUiTab__ReviewsGuideline {
  display: flex;
  align-items: center;
  gap: 4px;
  padding-left: 28px;
  font-size: 14px;
  color: #6D7175;
}

.BC-Klaviyo-WidgetUiTab__ReviewsGuideline .Polaris-Link {
  display: flex;
  align-items: center;
  gap: 5px;
}

.BC-Klaviyo-WidgetUiTab__Badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 1px solid #C9CCCF;
  font-size: 12px;
  color: #6D7175;
  flex-shrink: 0;
  background: #FFFFFF;
}

.BC-Klaviyo-WidgetUiTab__Title {
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 600;
  color: #6D7175;
  letter-spacing: 0.02em;
}

.BC-Klaviyo-WidgetUiTab__Body {
  background: #F6F6F7;
  padding: 12px 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Polaris draws its focus ring on the Backdrop's ::after (via the :focus ~ sibling selector in
   TextField.css/Select.css), not on the native input itself — suppressing it there is what
   actually removes it. Same technique already used for the rule row's fields. */
.BC-Klaviyo-WidgetUiTab__Body .Polaris-TextField__Input:focus ~ .Polaris-TextField__Backdrop::after,
.BC-Klaviyo-WidgetUiTab__Body .Polaris-Select__Input:focus ~ .Polaris-Select__Backdrop::after {
  box-shadow: none;
  outline: none;
}

.BC-Klaviyo-WidgetUiTab__Row {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  width: 100%;
}

/* Checkbox label + its dependent field stacked as one column, so the two Cols in a Row line up
   on the same "head" (the checkbox row) regardless of what's below it. */
.BC-Klaviyo-WidgetUiTab__Col {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* "Orientation options" title + its segmented button group — a plain TextStyle isn't a Polaris
   Labelled field, so it has no built-in label-to-field spacing the way Select/TextField do. */
.BC-Klaviyo-WidgetUiTab__OrientationGroup {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* Polaris' TextField always wraps itself in a Connected div (see TextField.js), which starts
   flush-left — indent it so its content lines up with the checkbox's own label text rather than
   the checkbox square: Polaris-Choice__Control is --p-choice-size (1.25rem) wide plus an
   --p-space-2 (0.5rem) margin-right before the label starts. */
.BC-Klaviyo-WidgetUiTab__Col .Polaris-Connected {
  margin-left: 1.75rem;
}

/* "Orientation options" segmented control — Polaris' pressed Button doesn't use Boost's
   Action Primary green (#008060) by default in this theme, so the selected segment is
   recolored to match Figma (23395:79622) directly. */
.BC-Klaviyo-WidgetUiTab__Orientation .Polaris-Button--pressed {
  background: #008060 !important;
  border-color: #008060 !important;
  color: #FFFFFF !important;
}

.BC-Klaviyo-WidgetUiTab__Orientation .Polaris-ButtonGroup,
.BC-Klaviyo-WidgetUiTab__Orientation .Polaris-ButtonGroup__Item {
  width: 100%;
}

.BC-Klaviyo-WidgetUiTab__Orientation .Polaris-Button {
  width: 100%;
  padding-top: 8px;
  padding-bottom: 8px;
}

/* Vertical rhythm between FormLayout rows (top-level fields, and each FormLayout.Group) is 12px
   — carried by Item's own margin-top, compensated by the container's negative margin so the
   first row doesn't get an extra 12px above it. Horizontal spacing between the 2 fields inside
   a row lives on Items' own flex \`gap\` instead of Item's margin-left, so the two concerns don't
   fight each other; Polaris' 2-column FormLayout.Group only wraps to 2-per-row when the
   container is wide enough, and the Settings column is 30% wide now, so nowrap forces it. */
.BC-Page.BC-Page__KlaviyoRecommendationBuilder .Polaris-FormLayout {
  margin-top: -12px;
  margin-left: 0;
}

.BC-Page.BC-Page__KlaviyoRecommendationBuilder .Polaris-FormLayout__Item {
  margin-top: 12px;
  margin-left: 0;
  max-width: 100%;
}

.BC-Page.BC-Page__KlaviyoRecommendationBuilder .Polaris-FormLayout__Items {
  display: flex;
  flex-wrap: nowrap;
  gap: 16px;
}

/* .Items has no align-items override (Polaris' own CSS), so it stretches each .Item to the
   row's tallest natural height by default — but RenderSelect/RenderTextField/
   RenderColorPickerSwatchInput's own wrapper div (label stacked above the control) isn't itself
   a flex column, so it never actually fills that stretched height; a field whose label wraps, or
   whose control has help/error text, would leave its shorter sibling's control sitting at a
   different vertical position even though the .Item boxes are already equal height. Making the
   wrapper a flex column and pinning it to the bottom keeps every control's baseline aligned
   across the row without stretching any control taller than its own natural size. */
.BC-Page.BC-Page__KlaviyoRecommendationBuilder .Polaris-FormLayout__Items .Polaris-FormLayout__Item {
  flex: 1 1 50%;
  min-width: 0;
  display: flex;
}

.BC-Page.BC-Page__KlaviyoRecommendationBuilder .Polaris-FormLayout__Items .Polaris-FormLayout__Item > div {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  flex: 1 1 auto;
  min-width: 0;
}

/* Color picker "swatch input" (Figma 23395:79685) — see render-color-picker-swatch-input.jsx.
   The button IS the field: its own background is the selected color, border/radius/height match
   the other Select/TextField controls in this tab, and the icon+hex text sit inline. */
.BC-ColorPickerSwatchInput {
  background-color: var(--swatch-bg, #FFFFFF);
  color: var(--swatch-text, #202223);
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  height: 36px;
  padding: 0 12px;
  border: 1px solid #E1E3E5;
  border-radius: 4px;
  font-size: 12px;
  line-height: 16px;
  cursor: pointer;
}

.BC-ColorPickerSwatchInput:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.BC-ColorPickerSwatchInput__Icon {
  display: inline-flex;
  flex-shrink: 0;
}

.BC-ColorPickerSwatchInput__Icon .Polaris-Icon {
  width: 12px;
  height: 12px;
}

/* Icon.css's own color-variant rules (e.g. .Polaris-Icon--colorInteractive svg{fill:...}) only
   apply when a Polaris \`color\` prop is passed — without one, the icon's raw SVG defaults to
   black. No \`color\` prop is passed here on purpose (the readable text/icon color is computed
   from the swatch's own background, not one of Polaris' fixed tokens), so fill has to be set
   directly to match the button's own text color. */
.BC-ColorPickerSwatchInput__Icon svg {
  fill: currentColor;
}

.BC-ColorPickerSwatchInput__ColorCode {
  line-height: 1;
}

/* "Text color" (Product title) sits alone in its FormLayout row, not inside a FormLayout.Group,
   so it isn't covered by the .Items 2-per-row rule above — cap it to the same column width as
   every other field in this tab instead of letting it flex-grow full width. A real 2-item .Items
   row splits its 16px \`gap\` out of the available width first, so each item is calc(50% - 8px),
   not a flat 50% — match that exactly here so this field's right edge lines up with the row
   above it instead of overhanging by half the gap. */
.BC-Page.BC-Page__KlaviyoRecommendationBuilder .Polaris-FormLayout__Item:has(.BC-ColorPickerSwatchInput__Wrapper) {
  flex: 0 1 calc(50% - 8px);
  max-width: calc(50% - 8px);
}

/* Get code modal (Figma 23395:77999) reuses the pre-existing .klaviyo-preview-modal shell/classes
   above (guideline, preview-content, title-section, feed-name, code, klaviyo-preview-modal__actions,
   product-container/product-item) so it stays pixel-identical to the modal that shipped this
   layout originally, including its preview panel — WidgetPreview's own device-frame layout is
   isolated to the builder page (see preview-products-modal.jsx's CustomRecommendationPreview). The only
   piece with no old equivalent is the feed-name copy badge, above (BC-Klaviyo-FeedBadge). */

/* Get code modal — replaces inline styles in preview-products-modal.jsx. */
.klaviyo-preview-modal .klaviyo-preview-modal__sync-banner {
  padding: 20px 24px;
}

.klaviyo-preview-modal .klaviyo-preview-modal__type-name {
  text-transform: capitalize;
}

.klaviyo-preview-modal .klaviyo-preview-modal__contact-link {
  text-decoration: underline;
  cursor: pointer;
}

.klaviyo-preview-modal .klaviyo-preview-modal__demo-note {
  text-align: center;
  margin-top: 24px;
}

.klaviyo-preview-modal .klaviyo-preview-modal__guideline .guide-content--spaced {
  margin-bottom: 16px;
}

.klaviyo-preview-modal .klaviyo-preview-modal__guideline .klaviyo-preview-modal__guide-list {
  padding-left: 16px;
}

.klaviyo-preview-modal .klaviyo-preview-modal__guideline .klaviyo-preview-modal__guide-list li:not(:last-child) {
  margin-bottom: 2px;
}

.klaviyo-preview-modal .klaviyo-preview-modal__guideline .code--spaced {
  margin-bottom: 8px;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__link {
  text-decoration: none;
}

/* Merchant-configured widgetUI values arrive as CSS variables set on .product-container--widget-ui;
   fallbacks keep the default look above when a value is unset. */
.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--widget-ui .product-item .product-item__info__title {
  font-family: var(--title-font, inherit);
  font-size: var(--title-size, 16px);
  color: var(--title-color, rgb(32, 34, 35));
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--widget-ui .product-item .product-item__info__price,
.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--widget-ui .product-item .product-item__info__compare-price {
  font-family: var(--price-font, inherit);
  font-size: var(--price-size, inherit);
  color: var(--original-price-color, #6D7175);
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--widget-ui .product-item .product-item__info__compare-price {
  color: var(--original-price-color, #9B9B9B);
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--widget-ui .product-item .product-item__info__price--sale {
  color: var(--sale-price-color, #6D7175);
}

/* Get code preview layout follows widgetUI: --columns products per row (1 for vertical), and
   vertical orientations put the image beside the info — right vertical mirrors it. */
.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--widget-ui .product-item {
  width: calc((100% - (var(--columns, 2) - 1) * 20px) / var(--columns, 2));
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--vertical .product-item .product-item__link {
  display: flex;
  align-items: center;
  gap: 16px;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--right-vertical .product-item .product-item__link {
  flex-direction: row-reverse;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--vertical .product-item .product-item__thumbnail {
  flex-shrink: 0;
  width: 160px;
  margin-bottom: 0;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--vertical .product-item .product-item__info {
  flex: 1;
}

/* Rating: same two lines and values as the builder's .BC-Klaviyo-RecommendationPreview__Rating. */
.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--widget-ui .product-item .product-item__info__rating {
  margin-top: 8px;
  text-align: center;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--widget-ui .product-item .product-item__info__stars {
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 1px;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--widget-ui .product-item .product-item__info__star--filled {
  color: #F0A93B;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--widget-ui .product-item .product-item__info__star--empty {
  color: #DDE2E7;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--widget-ui .product-item .product-item__info__review-count {
  margin-top: 4px;
  font-size: 12px;
  color: #9B9B9B;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--widget-ui .product-item .product-item__info__button-wrapper {
  margin-top: 8px;
  text-align: center;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--widget-ui .product-item .product-item__info__button {
  display: inline-block;
  padding: 8px 16px;
  border-radius: 4px;
  font-family: var(--button-font, inherit);
  font-size: var(--button-size, 14px);
  color: var(--button-color, #FFFFFF);
  background: var(--button-bg, #1A1A1A);
}

/* Recommendation builder — replaces inline styles in the views under
   src/components/views/klaviyo/recommendation/. */
.BC-Klaviyo-Recommendation__FilterCriteria {
  margin-top: 16px;
}

.BC-Klaviyo-Recommendation__RulesFooter {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.BC-Klaviyo-Recommendation__AttributeHint {
  color: #2C6ECB;
}

.BC-Klaviyo-RuleRowSelect__HelperText {
  margin-top: 0.25rem;
}

.BC-Klaviyo-TextFieldMax__HelperText {
  margin-top: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/klaviyo.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;;AAGA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,sEAAsE;EACtE,6BAA6B;EAC7B,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;;AAGA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AACV;;AAEA,2FAA2F;AAC3F;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,oFAAoF;AACpF;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;iDACiD;AACjD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA,2FAA2F;AAC3F;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,SAAS;EACT,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA;;;sFAGsF;AACtF;EACE,gBAAgB;EAChB,MAAM;EACN,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;sCAKsC;AACtC;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;;6FAE2F;EAC3F,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B;AACF;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iEAAiE;EACjE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;+BAE+B;AAC/B;EACE,wBAAwB;AAC1B;;AAEA;oEACoE;AACpE;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;;;sFAGsF;AACtF;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;;;;;kDAKkD;AAClD;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;;;;;;;qFAQqF;AACrF;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;;+DAG+D;AAC/D;EACE,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;EAC3B,WAAW;AACb;;AAEA;;sDAEsD;AACtD;EACE,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;4EAC4E;AAC5E;EACE,2EAA2E;EAC3E,cAAc;EACd,YAAY;EACZ,aAAa;AACf;;AAEA;;;;;oBAKoB;AACpB;EACE,cAAc;AAChB;;AAEA;;;mFAGmF;AACnF;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;qEAEqE;AACrE;EACE;wDACsD;EACtD,cAAc;EACd,+BAA+B;AACjC;;AAEA;;;EAGE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;wBAGwB;AACxB;;;;EAIE,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;;;;;;;EAOE,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B;;0EAEwE;EACxE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;AACA;;AAEA;;;GAGG;;AAEH;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oGAAoG;AACpG;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,0EAA0E;AAC1E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;;+DAE+D;AAC/D;EACE,eAAe;EACf,WAAW;EACX,MAAM;AACR;;AAEA,uGAAuG;AACvG;EACE;kFACgF;EAChF,YAAY;EACZ,+BAA+B;AACjC;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;kGACkG;AAClG;;;;;;EAME,SAAS;EACT,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;;;;EAIE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;2FAC2F;AAC3F;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA,0EAA0E;AAC1E;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;uFAGuF;AACvF;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;8FAC8F;AAC9F;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;+FAC+F;AAC/F;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;0EAG0E;AAC1E;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;gFACgF;AAChF;EACE,kDAAkD;EAClD,gBAAgB;EAChB,6CAA6C;EAC7C,kBAAkB;EAClB,gCAAgC;EAChC,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,gCAAgC;EAChC,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;0CAE0C;AAC1C;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;kGACkG;AAClG;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;gFAEgF;AAChF;;EAEE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,WAAW;AACb;;AAEA;yEACyE;AACzE;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;8FAC8F;AAC9F;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;;+DAG+D;AAC/D;EACE,oBAAoB;AACtB;;AAEA;;qDAEqD;AACrD;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;;4FAK4F;AAC5F;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,SAAS;AACX;;AAEA;;;;;;;oFAOoF;AACpF;EACE,aAAa;EACb,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;;AAEA;;uFAEuF;AACvF;EACE,2CAA2C;EAC3C,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;;mDAImD;AACnD;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;qDAKqD;AACrD;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;;;;4FAK4F;;AAE5F,2EAA2E;AAC3E;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;iEACiE;AACjE;EACE,uCAAuC;EACvC,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;;EAEE,uCAAuC;EACvC,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;qFACqF;AACrF;EACE,wEAAwE;AAC1E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,OAAO;AACT;;AAEA,kGAAkG;AAClG;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,mCAAmC;EACnC,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;kDACkD;AAClD;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-row {\n  display: flex;\n  gap: 20px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content {\n  width: 612px;\n  flex-shrink: 0;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .Polaris-Card {\n  height: 100%;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .Polaris-Card .card-inner {\n  padding: 16px;\n  height: 100%;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .Polaris-Card .card-inner.card-inner--column {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .Polaris-Card .card-inner .BC-Switch-Status {\n  height: 16px;\n  width: 34px;\n  margin-right: 8px;\n  display: inline-flex;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .Polaris-Card .card-inner .BC-Switch-Status__Bar {\n  width: 34px;\n  height: 16px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .Polaris-Card .card-inner .BC-Switch-Status__Dot {\n  width: 16px;\n  height: 16px;\n  transform: translateX(0);\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .Polaris-DataTable__Table {\n  border: 1px solid #E1E3E5;\n  border-radius: 8px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .Polaris-DataTable__Cell:first-child {\n  width: 45%;\n  white-space: wrap;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .Polaris-DataTable__Cell:last-child {\n  width: 55%;\n  white-space: wrap;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .Polaris-DataTable__TableRow:nth-child(odd) {\n  background-color: #FAFBFB;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .guide {\n  margin-bottom: 8px;\n  margin-top: 16px;\n  text-align: left;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .guide .Polaris-Link {\n  display: inline-flex;\n  align-items: center;\n  text-decoration: underline;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .guide .Polaris-Link .Polaris-Icon {\n  margin: 0;\n  width: 16px;\n  height: 16px;\n  margin-left: 2px;\n}\n\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .Polaris-DataTable__Navigation {\n  display: none;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .BC-Switch-Status input:checked+.BC-Switch-Status__Bar .BC-Switch-Status__Dot {\n  -webkit-transform: translateX(16px);\n  -ms-transform: translateX(16px);\n  transform: translateX(16px);\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .BC-Page__Title--Help {\n  padding-left: 53px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .divider {\n  border: 1px solid #E1E3E5;\n  margin-bottom: 24px;\n}\n\n.BC-Klaviyo-Recommendation__ListToolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.BC-Klaviyo-Recommendation__ListTitleGroup {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.BC-Klaviyo-Recommendation__CountBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 20px;\n  height: 20px;\n  padding: 2px 8px;\n  border-radius: 8px;\n  background: #E8E8E8;\n  font-size: 12px;\n}\n\n.BC-Klaviyo-Recommendation__MoreActionsMenu {\n  min-width: 130px;\n  text-align: left;\n}\n\n.BC-Klaviyo-Recommendation__ListLoading {\n  display: flex;\n  justify-content: center;\n  padding: 24px 0;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item {\n  display: grid;\n  grid-template-columns: 1fr 220px;\n  align-items: center;\n  gap: 32px;\n  padding: 12px 16px;\n  border: 1px solid transparent;\n  border-radius: 4px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item.recommendation-item--odd {\n  background: #FFFFFF;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item.recommendation-item--even {\n  background: #FAFBFB;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item:hover {\n  border: 1px solid #1F5199;\n  background: #EDF4FE;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item__title {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: 4px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .recommendation-item__title .text-ai {\n  background: linear-gradient(135.64deg, #C830E1 16.99%, #FE4A25 84.55%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  font-weight: 600;\n  font-size: 10px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .recommendation-item__title .star {\n  width: 12px;\n  height: 12px;\n  min-width: 12px;\n  min-height: 12px;\n  flex-shrink: 0;\n}\n\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .recommendation-item__title .Polaris-Badge {\n  background: #FF30001A;\n  padding: 2px 6px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .recommendation-item__title .Polaris-Badge>span {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item__header {\n  display: grid;\n  grid-template-columns: 1fr 220px;\n  align-items: center;\n  padding: 12px 16px;\n  margin-bottom: 8px;\n  background: #FAFBFB;\n  border: 1px solid #E1E3E5;\n  border-radius: 8px;\n  font-weight: 600;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item__header > :last-child {\n  text-align: center;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .recommendation-item__actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n/* 8px flex gap between action buttons, +4px on the more-actions trigger = 12px before it */\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .recommendation-item__actions .recommendation-item__more-actions {\n  margin-left: 4px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .recommendation-item__actions .recommendation-item__action-button .Polaris-Button {\n  padding: 5px 12px !important;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .recommendation-item__actions .recommendation-item__more-actions .Polaris-Button {\n  background: none;\n  color: #202223;\n  border: none;\n  box-shadow: none;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .recommendation-item__actions .recommendation-item__more-actions .Polaris-Button:disabled,\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .recommendation-item__actions .recommendation-item__more-actions .Polaris-Button[disabled] {\n  background: none;\n  color: #8C9196;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .text-coming-soon {\n  font-weight: 600;\n  font-size: 16px;\n  margin: 2px 0;\n  line-height: 24px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .card-inner--center {\n  text-align: center;\n  padding-bottom: 20px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .klaviyo-event {\n  border: 1px solid #E1E3E5;\n  border-radius: 8px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .klaviyo-event .klaviyo-event-collapse__toggle {\n  background-color: #FAFBFB;\n  padding: 12px 16px;\n  display: flex;\n  gap: 4px;\n  font-weight: 600;\n  cursor: pointer;\n  border-bottom: 1px solid #E1E3E5;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .klaviyo-event .klaviyo-event-wrapper:first-child .klaviyo-event-collapse__toggle {\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .klaviyo-event .klaviyo-event-wrapper:last-child .klaviyo-event-collapse__toggle {\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  border-bottom: 0;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .klaviyo-event .klaviyo-event-collapse__content {\n  padding: 12px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-bottom: 1px solid #E1E3E5;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .klaviyo-event .klaviyo-event-collapse__content .klaviyo-event-collapse__content__title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-basis: 50%;\n  padding-left: 24px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .klaviyo-event .klaviyo-event-collapse__content p {\n  flex-basis: 50%;\n  text-align: left;\n}\n\n/* Figma node 23395:77999 (Get code modal) — 980px total (600 info + 380 preview). */\n.BC-Page.BC-Page__KlaviyoIntegration~#PolarisPortalsContainer .Polaris-Modal-Dialog--sizeLarge {\n  max-width: 980px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .card-inner__flex {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .card-inner__flex .BC-Checkbox-Status {\n  margin-right: 0;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .card-inner__instruction {\n  padding-left: 42px;\n  margin-top: 4px;\n  color: rgb(109, 113, 117);\n  display: flex;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .card-inner__instruction .Polaris-Link {\n  display: inline-flex;\n  margin-left: 4px;\n  text-decoration: underline;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .card-inner__instruction .Polaris-Icon {\n  margin: 0;\n  width: 18px;\n  height: 18px;\n  margin-left: 2px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .card-inner__instruction .Polaris-Icon .Polaris-Icon__Svg {\n  fill: rgb(44, 110, 203);\n}\n\n.klaviyo-preview-modal {\n  display: flex;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline {\n  width: 600px;\n  padding: 16px;\n  border-right: 1px solid #E1E3E5;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline .title-section {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  margin-bottom: 8px;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline .Polaris-Link {\n  display: inline-flex;\n  align-items: center;\n  text-decoration: none;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline .feed-name {\n  display: flex;\n  align-items: center;\n  margin-bottom: 4px;\n  gap: 4px;\n}\n\n/* Figma node 23395:78022 — gray pill (not Polaris' Badge component), copy icon embedded inside\n   it rather than a separate button next to it. */\n.BC-Klaviyo-FeedBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  background: #E8E8E8;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.BC-Klaviyo-FeedBadge__Text {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1;\n  color: #616161;\n}\n\n.BC-Klaviyo-FeedBadge .Polaris-Icon {\n  width: 14px;\n  height: 14px;\n  margin: 0;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline .Polaris-Icon {\n  margin: 0;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline .guide-content .Polaris-Icon .Polaris-Icon__Svg {\n  fill: #2C6FCD;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline .code .Polaris-Icon .Polaris-Icon__Svg {\n  fill: #8C9196;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline .code .Polaris-Icon:hover .Polaris-Icon__Svg {\n  fill: rgb(26, 28, 29);\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline .klaviyo-preview-modal__actions .Polaris-ButtonGroup {\n  gap: 20px;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline .klaviyo-preview-modal__actions .Polaris-ButtonGroup__Item {\n  margin: 0;\n}\n\n/* Figma node 23395:78025 / 23395:78040 — bordered gray box, not just a scroll container. */\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline .code {\n  position: relative;\n  padding: 12px 16px;\n  background: #F5F5F5;\n  border: 1px solid #D0D0D0;\n  border-radius: 8px;\n  max-height: 414px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-width: thin;\n  scrollbar-gutter: stable;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline .code p {\n  white-space: pre-wrap;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  margin: 0;\n  font-family: Monaco, monospace;\n  font-size: 12px;\n  color: #202223;\n}\n\n/* Figma node 23395:78019/78040: copy icon in the box's top-right corner, set in by the box's own\n   padding. Sticky, not absolute — the box scrolls (max-height above), and an absolute child would\n   scroll away with long source code; sticky keeps it in view, like master's copy button did.\n   top matches the box's top padding so the icon doesn't jump when scrolling starts. */\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline .code .Polaris-Button {\n  position: sticky;\n  top: 0;\n  right: 0.25rem;\n  float: right;\n  margin-left: 8px;\n  padding: 0;\n  width: 16px;\n  height: 16px;\n  min-width: unset;\n  min-height: unset;\n}\n\n.klaviyo-preview-modal .loading-sync {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  padding: 20px 0;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content {\n  flex: 1;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .title-preview {\n  padding: 12px;\n  width: 100%;\n  border-bottom: 1px solid #E1E3E5;\n  text-align: center;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .preview-content {\n  padding: 16px 20px;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .preview-content--AI {\n  overflow: hidden;\n}\n\n/* Get code for a merchant-created recommendation shows up to 9 products (3x3 / 6 per row). The\n   Preview column matches the height of its sibling, the guideline column (the row stretches both),\n   and the products scroll inside it instead of stretching the modal. `height: 0` + `flex-grow`\n   keeps the products out of the column's own height, so only the guideline column sizes the row;\n   the scroll area then fills whatever the \"Preview\" title leaves. Declared after --AI so its\n   overflow-y wins for AI types too. */\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content--fit {\n  display: flex;\n  flex-direction: column;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content--fit .preview-content.preview-content--scroll .title-type {\n  /* BRD UC 3.2: a merchant-created recommendation's title renders exactly as entered — master's\n     uppercase on .title-type (declared below, 4 classes) stays for the 6 default recommendations'\n     legacy modal. The extra .preview-content class here (5 classes) is what lets this win. */\n  text-transform: none;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content--fit .preview-content--scroll {\n  flex: 1 1 0;\n  height: 0;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .preview-content .title-type {\n  font-weight: 600;\n  font-size: 20px;\n  text-transform: uppercase;\n  line-height: 32px;\n  text-align: center;\n  margin-bottom: 16px;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container {\n  display: flex;\n  flex-wrap: wrap;\n  column-gap: 20px;\n  row-gap: 16px;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item {\n  width: calc(50% - 10px);\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__thumbnail {\n  margin-bottom: 10px;\n  text-align: center;\n  aspect-ratio: 1;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__thumbnail img {\n  max-width: 100%;\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n  object-position: center;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__info__title {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  text-align: center;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  color: rgb(32, 34, 35);\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__info__price-wrapper {\n  text-align: center;\n  margin-top: 6px;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__info__price {\n  font-weight: 500;\n  color: #6D7175;\n  text-align: center;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__info__compare-price {\n  color: #9B9B9B;\n  text-decoration: line-through;\n  margin-left: 6px\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__thumbnail .Polaris-SkeletonThumbnail {\n  max-width: 100%;\n  height: 100%;\n  width: 100%;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__info .Polaris-SkeletonDisplayText__DisplayText {\n  width: 100%;\n  margin: auto;\n  height: 20px;\n  max-width: 6.5rem;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__info>.Polaris-SkeletonDisplayText__DisplayText {\n  max-width: 8rem;\n  height: 24px;\n}\n\n.callback-klaviyo {\n  box-shadow: 0px 2px 10px 0px #0000001A, 0px 0px 2px 0px #00000033;\n  background-color: #fff;\n  border-radius: 8px;\n  padding: 40px 48px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.callback-klaviyo .callback-klaviyo__title {\n  font-weight: 600;\n  font-size: 28px;\n  line-height: 32px;\n  text-align: center;\n  margin-top: 12px;\n  margin-bottom: 24px;\n}\n\n/* Klaviyo recommendation rule builder (create/edit Tab 1). Polaris' Stack spacing tokens don't\n   include a 16px step (loose=20px, baseTight=12px) — override the token directly rather than\n   reaching for inline style. */\n.BC-Page.BC-Page__KlaviyoRecommendationBuilder .Polaris-Stack--spacingLoose {\n  --pc-stack-spacing: 16px;\n}\n\n/* Two-tone card per Figma node 23395:78506 (Group Condition): a white header band for the\n   badge/label/delete, a light gray (#F6F6F7) body for the fields. */\n.BC-Klaviyo-Recommendation__RuleRow {\n  border: 1px solid #E1E3E5;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.BC-Klaviyo-Recommendation__RuleRow-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n}\n\n.BC-Klaviyo-Recommendation__RuleRow-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 4px;\n  border: 1px solid #C9CCCF;\n  font-size: 12px;\n  color: #6D7175;\n  flex-shrink: 0;\n  background: #FFFFFF;\n}\n\n.BC-Klaviyo-Recommendation__RuleRow-label {\n  text-transform: uppercase;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n}\n\n.BC-Klaviyo-Recommendation__RuleRow-delete {\n  margin-left: auto;\n}\n\n.BC-Klaviyo-Recommendation__RuleRow-body {\n  padding: 16px 6px 16px 12px;\n  background: #F6F6F7;\n  display: flex;\n  flex-direction: column;\n}\n\n.BC-Klaviyo-Recommendation__RuleRow-rangeError {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n  margin-top: 4px;\n  color: #D72C0D;\n  margin-left: 1rem;\n}\n\n.BC-Klaviyo-Recommendation__RuleRow-rangeError .Polaris-Icon {\n  margin: unset;\n}\n\n/* Line 1: attribute select + the conductor/value group side by side.\n   Every control shares one height via flex stretch, cascaded down through each wrapper with\n   height: 100% + box-sizing: border-box (so a wrapper's own border never adds on top of the\n   stretched size) instead of the same pixel value hardcoded at every nesting level. */\n.BC-Klaviyo-Recommendation__RuleRow-line1 {\n  display: flex;\n  gap: 8px;\n  align-items: stretch;\n}\n\n.BC-Klaviyo-Recommendation__RuleRow-attribute {\n  flex: 1 1 0;\n  min-width: 0;\n  display: flex;\n}\n\n/* The direct child here is RenderSelect's own unstyled wrapper div (label/tooltip — empty when,\n   as here, no label prop is passed — then the Polaris <Select>). Giving it height: 100% lets the\n   stretched height from -line1 keep propagating down to the actual Polaris control below.\n   flex: 1 1 auto is needed too — making -attribute/-conductor `display: flex` (above) turned\n   this div into a flex item, which shrinks to its content's width by default instead of filling\n   the row like a plain block-level child would. */\n.BC-Klaviyo-Recommendation__RuleRow-attribute > div {\n  flex: 1 1 auto;\n  min-width: 0;\n  height: 100%;\n  box-sizing: border-box;\n}\n\n/* -attribute now renders via react-select (RenderSelect3V2, classNamePrefix=\"BC-Select\") so it\n   can show a per-option hint + icon — Polaris' native <Select> can't render anything but plain\n   text inside an <option>. react-select's own root container (SelectContainer) renders with NO\n   class at all in its default state (`.BC-Select`/`.BC-Select-container` never match anything\n   real — its cx() state keys are all false), which is the one link a height:100% chain can't\n   pass through by class. RenderLabelTooltip renders nothing when no label is passed, so\n   SelectContainer is the only real DOM child here — reachable structurally instead: made\n   display:flex so its own child (.control) stretches to fill it the same native way -line1\n   stretches -attribute/-conductor, no fixed px value needed anywhere in the chain. */\n.BC-Klaviyo-Recommendation__RuleRow-attribute > div > div {\n  display: flex;\n  height: 100%;\n  box-sizing: border-box;\n}\n\n/* Belt-and-suspenders: force border-box on every react-select sub-part here (value-container,\n   indicators, etc.), not just .control — a single content-box element anywhere in this subtree\n   would silently add its own border/padding on top of the stretched height, growing .control\n   past the conductor's height despite the height:100% above. */\n.BC-Klaviyo-Recommendation__RuleRow-attribute [class*='BC-Select'] {\n  box-sizing: border-box !important;\n}\n\n.BC-Klaviyo-Recommendation__RuleRow-attribute .BC-Select__control {\n  height: 100%;\n  border: 1px solid #BABFC3 !important;\n  border-radius: 4px !important;\n  box-shadow: none !important;\n  width: 100%;\n}\n\n/* REVIEWS.io attribute options' hint icon — sized to match the 14px hint text next to it\n   instead of Polaris' default 20px Icon size (Icon.css sets a fixed 1.25rem box the inner svg\n   fills at 100%, so both need overriding together). */\n.BC-Klaviyo-Recommendation__AttributeHintIcon {\n  display: inline-flex;\n  margin-left: 4px;\n  vertical-align: text-bottom;\n}\n\n.BC-Klaviyo-Recommendation__AttributeHintIcon .Polaris-Icon {\n  width: 14px;\n  height: 14px;\n}\n\n/* Conductor + value group (Figma 23736:81860 \"<= | 90 $\", 23736:82019 \"is not | select\"): the\n   conductor select merged with its value field into one bordered control. */\n.BC-Klaviyo-Recommendation__RuleRow-valueGroup {\n  /* Figma 23736:81860/82019 split: ~41% attribute, ~55% conductor + value. */\n  flex: 1.35 1 0;\n  min-width: 0;\n  display: flex;\n}\n\n/* A LIST rule's picked values, in their own full-width row under -line1 (right-aligned, so they\n   line up under the value control) — however many lines they wrap to, -line1's controls keep\n   their single-line height. Deliberately no width-relative offset/flex split here: the rules\n   list (a Polaris Stack, a column flexbox) measures each rule's natural height in a pass where\n   such widths resolve narrower, so the tags wrapped there and left ~one tag-line of empty space\n   under the card. */\n.BC-Klaviyo-Recommendation__RuleRow-tagsRow {\n  display: block;\n}\n\n/* Margin lives here, not on -tagsRow: RenderSelectedTags renders nothing when no value is picked,\n   so an empty rule adds no extra space. Plain flex `gap` instead of a Polaris Stack: Stack spaces\n   its items through margins driven by the inherited --pc-stack-spacing variable, which this\n   builder overrides for its own Stacks (see .Polaris-Stack--spacingLoose above). */\n.BC-Klaviyo-Recommendation__RuleRow-tags {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 4px;\n  margin-top: 8px;\n}\n.BC-Klaviyo-Recommendation__RuleRow-compound {\n  display: flex;\n  flex: 1 1 0;\n  min-width: 0;\n  min-height: 36px;\n  border: 1px solid #C9CCCF;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n/* Conductor segment: Surface/Depressed (#EDEEEF) background, no border of its own — the\n   -compound wrapper draws the one outer border, this only the divider. Same \"merge two\n   controls\" technique as merchandising-v2's .wrap-attribute-field. */\n.BC-Klaviyo-Recommendation__RuleRow-compound-conductor {\n  /* Fits the widest operator (\"is not\") + chevron; anything wider squeezed the value field's\n     \"select\" placeholder in the 350px settings panel. */\n  flex: 0 0 76px;\n  border-right: 1px solid #C9CCCF;\n}\n\n.BC-Klaviyo-Recommendation__RuleRow-compound-conductor > div,\n.BC-Klaviyo-Recommendation__RuleRow-compound-conductor .Polaris-Select,\n.BC-Klaviyo-Recommendation__RuleRow-compound-conductor .Polaris-Select__Content {\n  height: 100%;\n  box-sizing: border-box;\n}\n\n.BC-Klaviyo-Recommendation__RuleRow-compound-conductor .Polaris-Select__Backdrop {\n  border: none !important;\n  box-shadow: none !important;\n  border-radius: 0;\n  background-color: #EDEEEF;\n}\n\n.BC-Klaviyo-Recommendation__RuleRow-compound-conductor .Polaris-Select__Input:focus ~ .Polaris-Select__Backdrop::after {\n  box-shadow: none;\n  outline: none;\n}\n\n.BC-Klaviyo-Recommendation__RuleRow-compound-field {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n/* Pin the field's own box to a constant height so hovering/focusing between inputs can't grow\n   or shrink it — Polaris toggles focus/hover via classes on these elements, not just\n   box-shadow/border, so height has to be pinned directly rather than relying on the state being\n   visually invisible. */\n.BC-Klaviyo-Recommendation__RuleRow-compound-field .Polaris-TextField,\n.BC-Klaviyo-Recommendation__RuleRow-compound-field .Polaris-TextField__Input,\n.BC-Klaviyo-Recommendation__RuleRow-compound-field .Polaris-Select,\n.BC-Klaviyo-Recommendation__RuleRow-compound-field .Polaris-Select__Input {\n  height: 36px !important;\n  box-sizing: border-box !important;\n}\n\n.BC-Klaviyo-Recommendation__RuleRow-compound-field .Polaris-TextField__Backdrop,\n.BC-Klaviyo-Recommendation__RuleRow-compound-field .Polaris-TextField__Backdrop:hover,\n.BC-Klaviyo-Recommendation__RuleRow-compound-field .Polaris-TextField__Backdrop::after,\n.BC-Klaviyo-Recommendation__RuleRow-compound-field .Polaris-Select__Backdrop,\n.BC-Klaviyo-Recommendation__RuleRow-compound-field .Polaris-Select__Backdrop:hover,\n.BC-Klaviyo-Recommendation__RuleRow-compound-field .Polaris-Select__Backdrop::after,\n.BC-Klaviyo-RecommendationBuilder__Settings .Polaris-TextField__Input ~ .Polaris-TextField__Backdrop::after {\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n  border-radius: 0;\n}\n\n.BC-Klaviyo-Recommendation__RuleRow-compound-field input:hover,\n.BC-Klaviyo-Recommendation__RuleRow-compound-field input:focus {\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n.BC-Klaviyo-Recommendation__RuleRow-compound-field .BC-Select__control {\n  border: none !important;\n  box-shadow: none !important;\n  border-radius: 0 !important;\n  /* react-select's control is flex-wrap: wrap — in the narrow settings panel the multi-select's\n     dropdown arrow wrapped onto a second line, growing the whole rule (and only LIST rules) to\n     ~70px. Keep it one line; the value container shrinks/clips instead. */\n  flex-wrap: nowrap;\n}\n\n.BC-Klaviyo-Recommendation__RuleRow-compound-field .BC-Select__dropdown-indicator {\n  padding: 8px 4px;\n}\n\n.BC-Klaviyo-Recommendation__RuleRow-compound-field .Polaris-TextField__Spinner {\n}\n\n/* .BC-Klaviyo-Recommendation__RuleRow-compound-field .Polaris-TextField__SpinnerIcon {\n  width: 20px;\n  height: 20px;\n} */\n\n.BC-Klaviyo-Recommendation__RuleRow-compound-field .Polaris-TextField__Segment {\n  width: 20px;\n  height: 14px;\n  min-width: 20px;\n  min-height: 14px;\n  max-width: 20px;\n  max-height: 14px;\n  flex-shrink: 0;\n}\n\n/* \"Filter criteria for recommended products\" section header + Refresh button above the rule list. */\n.BC-Klaviyo-Recommendation__FilterCriteriaHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n/* Rules count badge (e.g. \"4/4 rules\") shown once the limit is reached. */\n.BC-Klaviyo-Recommendation__RulesLimitBadge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 8px;\n  background: #FEDAD9;\n  color: #8E1F0B;\n  font-size: 12px;\n}\n\n/* Klaviyo recommendation builder — fullscreen chrome + left settings/right preview split,\n   mirroring merchandising-v2/rule's .merchandising-rule-body/-settings/-preview structure\n   (see merchandising.css) rather than a Polaris Page/Layout. */\n.BC-Page.BC-Page__KlaviyoRecommendationBuilder .Polaris-FullscreenBar {\n  position: fixed;\n  width: 100%;\n  top: 0;\n}\n\n/* Row 2 of the App Bridge drawer: exit + title hard-left, device toggle centred, actions hard-right. */\n.BC-Page.BC-Page__KlaviyoRecommendationBuilder .BC-FullscreenBar .Polaris-FullscreenBar__BackAction {\n  /* Design shows the exit icon only; the label stays in the DOM for screen readers. Polaris sizes\n     Icon in rem, so zeroing the font hides the text without shrinking the icon. */\n  font-size: 0;\n  border-right: 1px solid #E1E3E5;\n}\n\n.BC-Page.BC-Page__KlaviyoRecommendationBuilder\n  .BC-FullscreenBar\n  .Polaris-FullscreenBar__BackAction\n  .Polaris-Icon {\n  margin-right: 0;\n}\n\n/* Equal-flex outer zones put the middle zone on the true centre of the bar, whatever the title\n   length or action width — no negative-margin tuning like merchandising.css/theme-settings.css. */\n.BC-Page.BC-Page__KlaviyoRecommendationBuilder .BC-FullscreenBar .BC-FullscreenBar-Content_Title,\n.BC-Page.BC-Page__KlaviyoRecommendationBuilder\n  .BC-FullscreenBar\n  .Polaris-FullscreenBar__BackAction\n  + .BC-FullscreenBar-Content\n  .BC-FullscreenBar-Content_Title {\n  margin: 0;\n  flex: 1 1 0;\n  min-width: 0;\n  justify-content: flex-start;\n}\n\n.BC-Page.BC-Page__KlaviyoRecommendationBuilder\n  .BC-FullscreenBar\n  .BC-FullscreenBar-Content_Title\n  > span {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.BC-Page.BC-Page__KlaviyoRecommendationBuilder .BC-FullscreenBar .BC-FullscreenBar-Content_Middle {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n}\n\n.BC-Page.BC-Page__KlaviyoRecommendationBuilder .BC-FullscreenBar .BC-FullscreenBar-Content_Actions {\n  flex: 1 1 0;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.BC-Klaviyo-RecommendationBuilder__Body {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 3.5rem;\n  padding: 0;\n  gap: 20px;\n}\n\n.BC-Klaviyo-RecommendationBuilder__Loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 3.5rem;\n  padding: 80px 0;\n}\n\n.BC-Klaviyo-RecommendationBuilder__Settings {\n  width: 30%;\n  min-height: 980px;\n  background: #FFFFFF;\n  border: 1px solid #E1E3E5;\n}\n\n/* Figma's Left sidebar (23395:78497) has no side padding around its Tabs — they sit flush\n   against the pane's edges. Polaris' Tabs__Wrapper adds its own side padding by default. */\n.BC-Page.BC-Page__KlaviyoRecommendationBuilder .Polaris-Tabs__Wrapper {\n  padding: 0;\n}\n\n.BC-Klaviyo-RecommendationBuilder__Preview {\n  width: 70%;\n  display: flex;\n  justify-content: center;\n  padding-top: 20px;\n  background: #F1F2F3;\n}\n\n.BC-Klaviyo-RecommendationBuilder__Content {\n  margin-top: 16px;\n  padding: 16px 20px 16px 16px;\n}\n\n.BC-Klaviyo-RecommendationBuilder__Content .Polaris-Card {\n  border: none;\n  box-shadow: none;\n}\n\n.BC-Klaviyo-RecommendationBuilder__Banner {\n  margin-bottom: 16px;\n}\n\n.BC-Klaviyo-RecommendationBuilder__PreviewCount {\n  margin-bottom: 8px;\n}\n\n.BC-Klaviyo-RecommendationBuilder__PreviewList {\n  margin: 0;\n  padding-left: 20px;\n}\n\n.BC-Klaviyo-RecommendationBuilder__PreviewLoading {\n  display: flex;\n  justify-content: center;\n  padding: 20px 0;\n}\n\n/* Klaviyo recommendation widget preview (Tabs 1-2 right column + Tab 3) */\n.BC-Klaviyo-RecommendationPreview__Frame {\n  margin: 0 auto;\n}\n\n.BC-Klaviyo-RecommendationPreview__Frame--desktop {\n  width: 80%;\n  height: 100%;\n  overflow-y: auto;\n}\n\n.BC-Klaviyo-RecommendationPreview__Frame--mobile {\n  max-width: 320px;\n}\n\n.BC-Klaviyo-RecommendationPreview__Inner {\n  background: #FFFFFF;\n  border-radius: 12px;\n  padding: 48px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n/* Static — the \"Product title\"/\"Product price\"/\"Button\" config sections style each product\n   item in the grid below (BRD Screen 3 #3-#5), not this heading; the heading itself has no\n   font/size/color config in the BRD (Screen 3 #1 is just a checkbox + free text). No\n   text-transform: BRD UC 3.2 renders the title case-sensitively, exactly as entered. */\n.BC-Klaviyo-RecommendationPreview__Heading {\n  text-align: center;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 24px;\n  color: #202223;\n}\n\n.BC-Klaviyo-RecommendationPreview__Row {\n  display: flex;\n  justify-content: center;\n  gap: 40px;\n}\n\n.BC-Klaviyo-RecommendationPreview__Product {\n  text-align: center;\n  width: 160px;\n}\n\n/* Figma 23301:80994 (left) / 23301:80992 (right) — image and info side by side instead of\n   stacked; JS decides image/info order for left vs right, this just lays them out in a row. */\n.BC-Klaviyo-RecommendationPreview__Product--vertical {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  width: auto;\n}\n\n.BC-Klaviyo-RecommendationPreview__ProductInfo {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 180px;\n  text-align: center;\n}\n\n/* .ProductImage's own margin-bottom is for the stacked horizontal card — spacing between image\n   and info here is the flex row's own `gap` instead, so the image should sit flush/centered. */\n.BC-Klaviyo-RecommendationPreview__Product--vertical .BC-Klaviyo-RecommendationPreview__ProductImage {\n  margin: 0;\n  flex-shrink: 0;\n}\n\n.BC-Klaviyo-RecommendationPreview__ProductImage {\n  width: 160px;\n  height: 160px;\n  margin: 0 auto 10px;\n  text-align: center;\n  aspect-ratio: 1;\n}\n\n.BC-Klaviyo-RecommendationPreview__ProductImage img {\n  max-width: 100%;\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n  object-position: center;\n}\n\n/* Mobile always renders one product per row (see widget-preview.jsx), so horizontal cards keep\n   their desktop 160px size. Vertical cards follow Figma 23395:78177: full-width row, 123x150\n   image, info fills the rest — left-aligned for \"left vertically\", right-aligned for \"right\n   vertically\" (desktop keeps it centered), with a content-width button. */\n.BC-Klaviyo-RecommendationPreview__Frame--mobile .BC-Klaviyo-RecommendationPreview__Product--vertical {\n  width: 100%;\n  gap: 16px;\n}\n\n.BC-Klaviyo-RecommendationPreview__Frame--mobile .BC-Klaviyo-RecommendationPreview__Product--vertical .BC-Klaviyo-RecommendationPreview__ProductImage {\n  width: 123px;\n  height: 150px;\n  aspect-ratio: auto;\n}\n\n.BC-Klaviyo-RecommendationPreview__Frame--mobile .BC-Klaviyo-RecommendationPreview__ProductInfo {\n  flex: 1;\n  min-width: 0;\n  width: auto;\n  align-items: flex-start;\n  text-align: left;\n}\n\n.BC-Klaviyo-RecommendationPreview__Frame--mobile .BC-Klaviyo-RecommendationPreview__Product--right .BC-Klaviyo-RecommendationPreview__ProductInfo {\n  align-items: flex-end;\n  text-align: right;\n}\n\n.BC-Klaviyo-RecommendationPreview__Frame--mobile .BC-Klaviyo-RecommendationPreview__Product--vertical .BC-Klaviyo-RecommendationPreview__ButtonWrap {\n  margin-top: 12px;\n}\n\n.BC-Klaviyo-RecommendationPreview__Frame--mobile .BC-Klaviyo-RecommendationPreview__Product--vertical .BC-Klaviyo-RecommendationPreview__Button {\n  width: auto;\n  padding: 6px 16px;\n}\n\n/* Always 2 lines tall (longer titles clipped) so price and button line up across a row — the same\n   box the email source code uses; email clients can't bottom-align with flex. */\n.BC-Klaviyo-RecommendationPreview__ProductTitle {\n  height: calc(var(--preview-line-height, 20px) * 2);\n  overflow: hidden;\n  line-height: var(--preview-line-height, 20px);\n  margin-bottom: 6px;\n  font-family: var(--preview-font);\n  font-size: var(--preview-size);\n  color: var(--preview-color);\n}\n\n.BC-Klaviyo-RecommendationPreview__Price {\n  font-family: var(--preview-font);\n  font-size: var(--preview-size);\n}\n\n.BC-Klaviyo-RecommendationPreview__SalePrice {\n  color: var(--preview-color);\n}\n\n.BC-Klaviyo-RecommendationPreview__ComparePrice {\n  text-decoration: line-through;\n  color: var(--preview-color);\n}\n\n.BC-Klaviyo-RecommendationPreview__Rating {\n  margin-top: 8px;\n}\n\n.BC-Klaviyo-RecommendationPreview__Stars {\n  font-size: 14px;\n  line-height: 14px;\n  letter-spacing: 1px;\n}\n\n.BC-Klaviyo-RecommendationPreview__Star--filled {\n  color: #F0A93B;\n}\n\n.BC-Klaviyo-RecommendationPreview__Star--empty {\n  color: #DDE2E7;\n}\n\n.BC-Klaviyo-RecommendationPreview__ReviewCount {\n  margin-top: 4px;\n  font-size: 12px;\n  color: #9B9B9B;\n}\n\n.BC-Klaviyo-RecommendationPreview__ButtonWrap {\n  margin-top: 8px;\n}\n\n.BC-Klaviyo-RecommendationPreview__Button {\n  display: inline-block;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 8px 16px;\n  border-radius: 100px;\n  font-family: var(--preview-font);\n  font-size: var(--preview-size);\n  color: var(--preview-color);\n  background: var(--preview-bg);\n  text-align: center;\n}\n\n.BC-Klaviyo-RecommendationPreview__Empty {\n  text-align: center;\n  color: #6D7175;\n}\n\n.BC-Klaviyo-RecommendationPreview__DemoNote {\n  margin: 0;\n  text-align: center;\n}\n\n.BC-Klaviyo-RecommendationPreview__Loading {\n  display: flex;\n  justify-content: center;\n  padding: 80px 0;\n}\n\n/* Widget UI tab (Customize widget UI, Figma node 23395:79477) — each section is a numbered\n   \"Group Condition\" box, same visual pattern as the rule builder's RuleRow (bordered header +\n   gray body), not a plain Polaris Card. */\n.BC-Klaviyo-WidgetUiTab__Section {\n  border: 1px solid #E1E3E5;\n  border-radius: 8px;\n  overflow: hidden;\n  margin-bottom: 16px;\n}\n\n.BC-Klaviyo-WidgetUiTab__Heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px;\n}\n\n.BC-Klaviyo-WidgetUiTab__HeadingLeft {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Figma 23525:79672 — \"Guideline: How to integrate with REVIEWS.io\" link, indented to align\n   under the checkbox's own label text (20px checkbox + 8px gap), shown only while disconnected. */\n.BC-Klaviyo-WidgetUiTab__ReviewsGuideline {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding-left: 28px;\n  font-size: 14px;\n  color: #6D7175;\n}\n\n.BC-Klaviyo-WidgetUiTab__ReviewsGuideline .Polaris-Link {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.BC-Klaviyo-WidgetUiTab__Badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 4px;\n  border: 1px solid #C9CCCF;\n  font-size: 12px;\n  color: #6D7175;\n  flex-shrink: 0;\n  background: #FFFFFF;\n}\n\n.BC-Klaviyo-WidgetUiTab__Title {\n  text-transform: uppercase;\n  font-size: 12px;\n  font-weight: 600;\n  color: #6D7175;\n  letter-spacing: 0.02em;\n}\n\n.BC-Klaviyo-WidgetUiTab__Body {\n  background: #F6F6F7;\n  padding: 12px 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* Polaris draws its focus ring on the Backdrop's ::after (via the :focus ~ sibling selector in\n   TextField.css/Select.css), not on the native input itself — suppressing it there is what\n   actually removes it. Same technique already used for the rule row's fields. */\n.BC-Klaviyo-WidgetUiTab__Body .Polaris-TextField__Input:focus ~ .Polaris-TextField__Backdrop::after,\n.BC-Klaviyo-WidgetUiTab__Body .Polaris-Select__Input:focus ~ .Polaris-Select__Backdrop::after {\n  box-shadow: none;\n  outline: none;\n}\n\n.BC-Klaviyo-WidgetUiTab__Row {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  width: 100%;\n}\n\n/* Checkbox label + its dependent field stacked as one column, so the two Cols in a Row line up\n   on the same \"head\" (the checkbox row) regardless of what's below it. */\n.BC-Klaviyo-WidgetUiTab__Col {\n  flex: 1 1 0;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* \"Orientation options\" title + its segmented button group — a plain TextStyle isn't a Polaris\n   Labelled field, so it has no built-in label-to-field spacing the way Select/TextField do. */\n.BC-Klaviyo-WidgetUiTab__OrientationGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n/* Polaris' TextField always wraps itself in a Connected div (see TextField.js), which starts\n   flush-left — indent it so its content lines up with the checkbox's own label text rather than\n   the checkbox square: Polaris-Choice__Control is --p-choice-size (1.25rem) wide plus an\n   --p-space-2 (0.5rem) margin-right before the label starts. */\n.BC-Klaviyo-WidgetUiTab__Col .Polaris-Connected {\n  margin-left: 1.75rem;\n}\n\n/* \"Orientation options\" segmented control — Polaris' pressed Button doesn't use Boost's\n   Action Primary green (#008060) by default in this theme, so the selected segment is\n   recolored to match Figma (23395:79622) directly. */\n.BC-Klaviyo-WidgetUiTab__Orientation .Polaris-Button--pressed {\n  background: #008060 !important;\n  border-color: #008060 !important;\n  color: #FFFFFF !important;\n}\n\n.BC-Klaviyo-WidgetUiTab__Orientation .Polaris-ButtonGroup,\n.BC-Klaviyo-WidgetUiTab__Orientation .Polaris-ButtonGroup__Item {\n  width: 100%;\n}\n\n.BC-Klaviyo-WidgetUiTab__Orientation .Polaris-Button {\n  width: 100%;\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n/* Vertical rhythm between FormLayout rows (top-level fields, and each FormLayout.Group) is 12px\n   — carried by Item's own margin-top, compensated by the container's negative margin so the\n   first row doesn't get an extra 12px above it. Horizontal spacing between the 2 fields inside\n   a row lives on Items' own flex `gap` instead of Item's margin-left, so the two concerns don't\n   fight each other; Polaris' 2-column FormLayout.Group only wraps to 2-per-row when the\n   container is wide enough, and the Settings column is 30% wide now, so nowrap forces it. */\n.BC-Page.BC-Page__KlaviyoRecommendationBuilder .Polaris-FormLayout {\n  margin-top: -12px;\n  margin-left: 0;\n}\n\n.BC-Page.BC-Page__KlaviyoRecommendationBuilder .Polaris-FormLayout__Item {\n  margin-top: 12px;\n  margin-left: 0;\n  max-width: 100%;\n}\n\n.BC-Page.BC-Page__KlaviyoRecommendationBuilder .Polaris-FormLayout__Items {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 16px;\n}\n\n/* .Items has no align-items override (Polaris' own CSS), so it stretches each .Item to the\n   row's tallest natural height by default — but RenderSelect/RenderTextField/\n   RenderColorPickerSwatchInput's own wrapper div (label stacked above the control) isn't itself\n   a flex column, so it never actually fills that stretched height; a field whose label wraps, or\n   whose control has help/error text, would leave its shorter sibling's control sitting at a\n   different vertical position even though the .Item boxes are already equal height. Making the\n   wrapper a flex column and pinning it to the bottom keeps every control's baseline aligned\n   across the row without stretching any control taller than its own natural size. */\n.BC-Page.BC-Page__KlaviyoRecommendationBuilder .Polaris-FormLayout__Items .Polaris-FormLayout__Item {\n  flex: 1 1 50%;\n  min-width: 0;\n  display: flex;\n}\n\n.BC-Page.BC-Page__KlaviyoRecommendationBuilder .Polaris-FormLayout__Items .Polaris-FormLayout__Item > div {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n/* Color picker \"swatch input\" (Figma 23395:79685) — see render-color-picker-swatch-input.jsx.\n   The button IS the field: its own background is the selected color, border/radius/height match\n   the other Select/TextField controls in this tab, and the icon+hex text sit inline. */\n.BC-ColorPickerSwatchInput {\n  background-color: var(--swatch-bg, #FFFFFF);\n  color: var(--swatch-text, #202223);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  height: 36px;\n  padding: 0 12px;\n  border: 1px solid #E1E3E5;\n  border-radius: 4px;\n  font-size: 12px;\n  line-height: 16px;\n  cursor: pointer;\n}\n\n.BC-ColorPickerSwatchInput:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.BC-ColorPickerSwatchInput__Icon {\n  display: inline-flex;\n  flex-shrink: 0;\n}\n\n.BC-ColorPickerSwatchInput__Icon .Polaris-Icon {\n  width: 12px;\n  height: 12px;\n}\n\n/* Icon.css's own color-variant rules (e.g. .Polaris-Icon--colorInteractive svg{fill:...}) only\n   apply when a Polaris `color` prop is passed — without one, the icon's raw SVG defaults to\n   black. No `color` prop is passed here on purpose (the readable text/icon color is computed\n   from the swatch's own background, not one of Polaris' fixed tokens), so fill has to be set\n   directly to match the button's own text color. */\n.BC-ColorPickerSwatchInput__Icon svg {\n  fill: currentColor;\n}\n\n.BC-ColorPickerSwatchInput__ColorCode {\n  line-height: 1;\n}\n\n/* \"Text color\" (Product title) sits alone in its FormLayout row, not inside a FormLayout.Group,\n   so it isn't covered by the .Items 2-per-row rule above — cap it to the same column width as\n   every other field in this tab instead of letting it flex-grow full width. A real 2-item .Items\n   row splits its 16px `gap` out of the available width first, so each item is calc(50% - 8px),\n   not a flat 50% — match that exactly here so this field's right edge lines up with the row\n   above it instead of overhanging by half the gap. */\n.BC-Page.BC-Page__KlaviyoRecommendationBuilder .Polaris-FormLayout__Item:has(.BC-ColorPickerSwatchInput__Wrapper) {\n  flex: 0 1 calc(50% - 8px);\n  max-width: calc(50% - 8px);\n}\n\n/* Get code modal (Figma 23395:77999) reuses the pre-existing .klaviyo-preview-modal shell/classes\n   above (guideline, preview-content, title-section, feed-name, code, klaviyo-preview-modal__actions,\n   product-container/product-item) so it stays pixel-identical to the modal that shipped this\n   layout originally, including its preview panel — WidgetPreview's own device-frame layout is\n   isolated to the builder page (see preview-products-modal.jsx's CustomRecommendationPreview). The only\n   piece with no old equivalent is the feed-name copy badge, above (BC-Klaviyo-FeedBadge). */\n\n/* Get code modal — replaces inline styles in preview-products-modal.jsx. */\n.klaviyo-preview-modal .klaviyo-preview-modal__sync-banner {\n  padding: 20px 24px;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__type-name {\n  text-transform: capitalize;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__contact-link {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__demo-note {\n  text-align: center;\n  margin-top: 24px;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline .guide-content--spaced {\n  margin-bottom: 16px;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline .klaviyo-preview-modal__guide-list {\n  padding-left: 16px;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline .klaviyo-preview-modal__guide-list li:not(:last-child) {\n  margin-bottom: 2px;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline .code--spaced {\n  margin-bottom: 8px;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__link {\n  text-decoration: none;\n}\n\n/* Merchant-configured widgetUI values arrive as CSS variables set on .product-container--widget-ui;\n   fallbacks keep the default look above when a value is unset. */\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--widget-ui .product-item .product-item__info__title {\n  font-family: var(--title-font, inherit);\n  font-size: var(--title-size, 16px);\n  color: var(--title-color, rgb(32, 34, 35));\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--widget-ui .product-item .product-item__info__price,\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--widget-ui .product-item .product-item__info__compare-price {\n  font-family: var(--price-font, inherit);\n  font-size: var(--price-size, inherit);\n  color: var(--original-price-color, #6D7175);\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--widget-ui .product-item .product-item__info__compare-price {\n  color: var(--original-price-color, #9B9B9B);\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--widget-ui .product-item .product-item__info__price--sale {\n  color: var(--sale-price-color, #6D7175);\n}\n\n/* Get code preview layout follows widgetUI: --columns products per row (1 for vertical), and\n   vertical orientations put the image beside the info — right vertical mirrors it. */\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--widget-ui .product-item {\n  width: calc((100% - (var(--columns, 2) - 1) * 20px) / var(--columns, 2));\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--vertical .product-item .product-item__link {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--right-vertical .product-item .product-item__link {\n  flex-direction: row-reverse;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--vertical .product-item .product-item__thumbnail {\n  flex-shrink: 0;\n  width: 160px;\n  margin-bottom: 0;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--vertical .product-item .product-item__info {\n  flex: 1;\n}\n\n/* Rating: same two lines and values as the builder's .BC-Klaviyo-RecommendationPreview__Rating. */\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--widget-ui .product-item .product-item__info__rating {\n  margin-top: 8px;\n  text-align: center;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--widget-ui .product-item .product-item__info__stars {\n  font-size: 14px;\n  line-height: 14px;\n  letter-spacing: 1px;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--widget-ui .product-item .product-item__info__star--filled {\n  color: #F0A93B;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--widget-ui .product-item .product-item__info__star--empty {\n  color: #DDE2E7;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--widget-ui .product-item .product-item__info__review-count {\n  margin-top: 4px;\n  font-size: 12px;\n  color: #9B9B9B;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--widget-ui .product-item .product-item__info__button-wrapper {\n  margin-top: 8px;\n  text-align: center;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container--widget-ui .product-item .product-item__info__button {\n  display: inline-block;\n  padding: 8px 16px;\n  border-radius: 4px;\n  font-family: var(--button-font, inherit);\n  font-size: var(--button-size, 14px);\n  color: var(--button-color, #FFFFFF);\n  background: var(--button-bg, #1A1A1A);\n}\n\n/* Recommendation builder — replaces inline styles in the views under\n   src/components/views/klaviyo/recommendation/. */\n.BC-Klaviyo-Recommendation__FilterCriteria {\n  margin-top: 16px;\n}\n\n.BC-Klaviyo-Recommendation__RulesFooter {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.BC-Klaviyo-Recommendation__AttributeHint {\n  color: #2C6ECB;\n}\n\n.BC-Klaviyo-RuleRowSelect__HelperText {\n  margin-top: 0.25rem;\n}\n\n.BC-Klaviyo-TextFieldMax__HelperText {\n  margin-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
